<template>
  <div role="form">
    <div class="form-group">
      <label>First name</label>
      <input v-model="firstName" type="text" class="form-control">
    </div>
    <div class="form-group">
      <label>Last name</label>
      <input v-model="lastName" type="text" class="form-control">
    </div>
    <!-- In the app the native nav bar's Save stands in for Update -->
    <div v-if="!forAppEmbed" class="button-area text-right">
      <ladda-button @lbClicked="updateParent" el-class="btn-primary" :loading="loading">
        Update
      </ladda-button>
      <div v-show="error">
        <small>
          <span class="text-danger">{{ errorMessage }}</span>
        </small>
      </div>
    </div>
  </div>
</template>
<script>
import LaddaButton from '../../shared/ladda_button.vue';
import { errorableMix } from './mixins/errorable_mix';
import { appEmbedMix } from './mixins/app_embed_mix';

export default {
  name: 'parent-edit',
  components: { LaddaButton },
  mixins: [errorableMix, appEmbedMix],
  props: {
    existingFirstName: {
      type: String,
      required: true,
    },
    existingLastName: {
      type: String,
      required: true,
    },
    parentId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      firstName: '',
      lastName: '',
    };
  },
  created() {
    this.firstName = this.existingFirstName;
    this.lastName = this.existingLastName;
  },
  mounted() {
    this.setupNativeSaveButton(this.updateParent);
  },
  methods: {
    updateParent() {
      const vm = this;
      vm.clearError();

      if (this.firstName.length === 0) {
        this.showError("First name can't be blank");
        this.notifyAppOfValidationError("First name can't be blank");
        return;
      }

      if (this.lastName.length === 0) {
        this.showError("Last name can't be blank");
        this.notifyAppOfValidationError("Last name can't be blank");
        return;
      }

      if (vm.loading === true) {
        return;
      }

      const params = {
        parent_profile: {
          first_name: vm.firstName,
          last_name: vm.lastName,
        },
      };

      vm.loading = true;
      const url = vm.$apiService.parentUrl(vm.parentId);
      axios.put(url, params)
        .then((response) => {
          vm.loading = false;
          if (vm.forAppEmbed) {
            vm.askAppToPop({ name: 'parent_updated', data: { parent_id: vm.parentId } });
            return;
          }
          vm.$notificationManager.emit('show-toast', 'Info updated', true);
          window.location.assign(`/parents/${vm.parentId}`);
        })
        .catch((error) => {
          vm.loading = false;
          vm.errorMessage = 'Error, please try again later or contact support@wrestlingiq.com';
          vm.error = true;
          vm.notifyAppOfValidationError(vm.errorMessage);
        });
    },
  },
};
</script>
<style scoped>
</style>
